
export default {

    created() {
        let { title } = this.$options;
        if (title) {
            title = typeof title === 'function' ? title.call(this) : title;
            const appName = this.$i18n.t('appName');
            document.title = `${title} | ${appName}`;
        }
    }
}
